import { ApplyModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { SingleDataStore } from "../../../../../Shared/Stores/SingleDataStore";
import { FullClientDetailModel } from "../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { ProductWrapper } from "../../../../../../Wrap/Models/Domains/Account/ProductWrapper";
import { SingleDataStoreDispacher } from "../../../../../Shared/Stores/SingleDataStoreDispacher";

export const NewBusinessDispatcher: SingleDataStoreDispacher<ApplyModel> = new SingleDataStoreDispacher<ApplyModel>();
export const NewBusinessStore: SingleDataStore<ApplyModel> = new SingleDataStore<ApplyModel>(NewBusinessDispatcher);

export const CustomerContextDispatcher: SingleDataStoreDispacher<FullClientDetailModel> = new SingleDataStoreDispacher<
    FullClientDetailModel
>();
export const CustomerContextStoreStatic: SingleDataStore<FullClientDetailModel> = new SingleDataStore<
    FullClientDetailModel
>(CustomerContextDispatcher);
export const AdviserContextDisaptcher: SingleDataStoreDispacher<Adviser> = new SingleDataStoreDispacher<Adviser>();
export const AdviserContextStoreStatic: SingleDataStore<Adviser> = new SingleDataStore<Adviser>(
    AdviserContextDisaptcher
);
export const ProductWrapperDispatcher: SingleDataStoreDispacher<ProductWrapper[]> = new SingleDataStoreDispacher<
    ProductWrapper[]
>();
export const ProductWrapperStore: SingleDataStore<ProductWrapper[]> = new SingleDataStore<ProductWrapper[]>(
    ProductWrapperDispatcher
);
